import {
   Actions, CollectionDescriptor, Root, ReadOptions
} from 'firestar'
import { WriteOptions } from 'firestar/lib/CollectionDescriptor'
import Casinos from './Casinos'
import Promotions from './Promotions'

interface VoucherInfoType {
   id: string,
   name: string,
   params?: { [key: string]: any } | null
}

interface VoucherType extends VoucherInfoType, Root {
   casinoInfo: Casinos.CasinoInfo,
   promotionInfo: Promotions.PromotionInfo
   name: string
}

namespace Vouchers {

   export type Voucher = VoucherType
   export type VoucherInfo = VoucherInfoType

   export function getVouchers(
      casinoId: string,
      promotionId: string,
      descriptor?: CollectionDescriptor
   ) {
      return Actions.readCollection<Voucher>(`casinos/${casinoId}/promotions/${promotionId}/vouchers`, descriptor)
   }

   export function getVoucherInfo(voucher: Voucher): VoucherInfo {
      return {
         id: voucher.id,
         name: voucher.name
      }
   }

   export function update(
      casinoId: string,
      promotionId: string,
      voucherId: string,
      document: Voucher | Partial<Voucher>
   ) {
      return Actions.updateDocument<Voucher>(`casinos/${casinoId}/promotions/${promotionId}/vouchers/${voucherId}`, document)
   }

   export function deleteVoucher(
      casinoId: string,
      promotionId: string,
      voucherId: string
   ) {
      return Actions.deleteDocument(`casinos/${casinoId}/promotions/${promotionId}/vouchers/${voucherId}`)
   }

   export function createVoucher(
      casinoId: string,
      promotionId: string,
      document: Voucher,
      options?: WriteOptions
   ) {
      return Actions.addToCollection<Voucher>(
         `casinos/${casinoId}/promotions/${promotionId}/vouchers`,
         document,
         options
      )
   }

   export function getVoucher(
      voucherId: string,
      readOptions?: ReadOptions
   ) {
      return new Promise<undefined | Voucher>(async (resolve, reject) => {
         try {
            const response = await Actions.readCollectionGroup<Voucher>('vouchers', {
               where: [
                  {
                     fieldPath: 'id',
                     opStr: '==',
                     value: voucherId
                  }
               ]
            }, readOptions)
            if (response.data.length === 1) {
               resolve(response.data[0])
            } else {
               resolve(undefined)
            }
         } catch (error) {
            reject(error)
         }
      })
   }

   export function getVoucherForPromotion(
      casinoId: string,
      promotionId: string,
      descriptor?: CollectionDescriptor
   ) {
      return Actions.readCollection<Voucher>(`casinos/${casinoId}/promotions/${promotionId}/vouchers`, descriptor)
   }
}

export default Vouchers